import type { GQL_ID } from '@@partner:types:graphql'
import type { CustomerInfo } from '@@partner:types:app'

import { gql, useQuery } from '@apollo/client'

import { SHORTCUT_CUSTOMERS_FIELDS } from '@@partner:graphql/shortcuts'

export interface SingleCustomerQuery {
  customer: CustomerInfo
}
export interface SingleCustomerQueryVariables {
  id?: GQL_ID
}

export const GQL_QUERY_SINGLE_CUSTOMER = gql`
  query singleCustomer (
    $id: ID!
    $style: String
  ) {
    customer: singleCustomer(id: $id) {
      ${SHORTCUT_CUSTOMERS_FIELDS}
      ordersCount
      feedbacks {
        id
        brand_id
        order_id
        review
        general_rating
        need_call
        images(style: $style) {
          url
        }

      }
    }
  }
`

export const useFetchSingleCustomer = (
  variables: SingleCustomerQueryVariables
) => {
  return useQuery<SingleCustomerQuery, SingleCustomerQueryVariables>(
    GQL_QUERY_SINGLE_CUSTOMER,
    {
      variables,
      skip: !variables.id
    }
  )
}
